/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect, useContext } from 'react'
import { initialQueryState, KTSVG, useDebounce } from '../../_metronic/helpers'
import { useQueryRequest } from './request'
import { ComponentRequest } from './componentLayout'
/**
 * SearchComponent
 *
 * Provides a debounced search input for filtering data in user tables and lists.
 *
 * Features:
 * - Debounces search input to reduce API calls
 * - Updates global query state for data filtering
 * - Supports custom class for styling
 * - Displays dynamic placeholder based on context
 *
 * Props:
 * - OptionalClass: Custom class name for styling (optional)
 */
const SearchComponent = ({ OptionalClass = null }) => {
    const { updateState } = useQueryRequest()
    const [searchTerm, setSearchTerm] = useState('')
    const { comRequest } = useContext(ComponentRequest)
    // Debounce search term so that it only gives us latest value ...
    // ... if searchTerm has not been updated within last 500ms.
    // The goal is to only have the API call fire when user stops typing ...
    // ... so that we aren't hitting our API rapidly.
    const debouncedSearchTerm = useDebounce(searchTerm, 150)
    // Effect for API call
    useEffect(() => {
        if (
            (comRequest.type === 'brand' || comRequest.type === 'business' || comRequest.type === 'categoryList') &&
            debouncedSearchTerm !== undefined && debouncedSearchTerm.length >= 2
        ) {
            updateState({ search: debouncedSearchTerm, ...initialQueryState });
        } else if (debouncedSearchTerm !== undefined && debouncedSearchTerm.length >= 3) {
            updateState({ search: debouncedSearchTerm, ...initialQueryState });
        } else {
            // Reset data or perform other actions when search term is empty
            // You might want to set an empty array or do something specific
            updateState({ search: '', ...initialQueryState });
            // Reset your data or take appropriate actions
        }
    }, [debouncedSearchTerm]);


    return (
        <div className={`${OptionalClass ? OptionalClass : 'card-title'}`}>
            {/* begin::Search */}
            <div className='d-flex align-items-center position-relative my-1'>
                <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-1 position-absolute ms-6'
                />
                <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-14'
                    placeholder={`Search  ${comRequest?.search ? 'By ' + comRequest?.search : comRequest?.label}`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            {/* end::Search */}
        </div>
    )
}

export { SearchComponent }
